import { useState } from "react";
import { Badge, Card, Col, Modal, Row, Table, Button } from "@themesberg/react-bootstrap";
import moment from "moment";
import ImagePreview from "../partials/image-preview/ImagePreview";
import { getLotoTypeLabelWithFilter } from "../../../../helper/lotoType";

const formatDateTime = (value) => {
  if (!value) return "-";
  const m = moment(value);
  if (!m.isValid()) return String(value);
  return m.format("DD/MM/YYYY HH:mm");
};

const formatVnd = (value) => {
  const numericValue = Number(value || 0);
  if (!Number.isFinite(numericValue)) return "-";
  return numericValue.toLocaleString("vi-VN") + "đ";
};

export default function CartDetailModal({ show, onHide, cart }) {
  const [imagePreviewShow, setImagePreviewShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageTitle, setSelectedImageTitle] = useState("");

  const showImagePreview = (title, image) => {
    setSelectedImageTitle(title);
    setSelectedImage(image);
    setImagePreviewShow(true);
  };

  if (!cart) return null;

  const {
    id, user, createdAt, channel, resultDate,
    value, lotoType, numbers, images,
    doneAt, amount10, amount20, amount50, isDone,
    baoFilter, baoDigits,
  } = cart;

  const statusBadge = isDone === 1
    ? <Badge bg="success" className="px-3 py-2">Hoàn thành</Badge>
    : <Badge bg="warning" text="dark" className="px-3 py-2">Đơn mới</Badge>;

  const totalSheets = (amount10 || 0) + (amount20 || 0) + (amount50 || 0);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        scrollable
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            Chi tiết đơn hàng Loto #{id}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-3">
            {/* Thông tin đơn hàng */}
            <Col md={6}>
              <Card border="light" className="shadow-sm h-100">
                <Card.Header className="d-flex justify-content-between align-items-center bg-light">
                  <span className="fw-bold">Thông tin đơn hàng</span>
                  {statusBadge}
                </Card.Header>
                <Card.Body>
                  <Table responsive size="sm" className="mb-0">
                    <tbody>
                      <tr>
                        <td className="text-muted" style={{ width: 120 }}>Mã đơn</td>
                        <td className="fw-bold text-primary">{id}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Loại lô</td>
                        <td className="fw-bold">{getLotoTypeLabelWithFilter(lotoType, baoFilter, baoDigits)}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Số chơi</td>
                        <td className="fw-bold text-primary" style={{ letterSpacing: "2px" }}>{numbers}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Giá vé</td>
                        <td className="fw-bold text-success">{formatVnd(value)}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Kỳ quay</td>
                        <td>
                          {channel}
                          {resultDate && <span className="text-primary ms-1">- {resultDate}</span>}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-muted">Ngày tạo</td>
                        <td>{formatDateTime(createdAt)}</td>
                      </tr>
                      {doneAt && (
                        <tr>
                          <td className="text-muted">Ngày xuất</td>
                          <td>{formatDateTime(doneAt)}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>

            {/* Người chơi */}
            <Col md={6}>
              <Card border="light" className="shadow-sm h-100">
                <Card.Header className="bg-light fw-bold">Người chơi</Card.Header>
                <Card.Body>
                  <Table responsive size="sm" className="mb-0">
                    <tbody>
                      <tr>
                        <td className="text-muted" style={{ width: 120 }}>Mã KH</td>
                        <td className="fw-bold">{(user && user.endPointId) || "-"}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Tên</td>
                        <td className="fw-bold">{(user && user.name) || "-"}</td>
                      </tr>
                      <tr>
                        <td className="text-muted">Số điện thoại</td>
                        <td className="fw-bold text-primary">{(user && user.phone) || "-"}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>

            {/* Số tờ */}
            {isDone === 1 && totalSheets > 0 && (
              <Col md={6}>
                <Card border="light" className="shadow-sm h-100">
                  <Card.Header className="bg-light fw-bold">Số tờ vé</Card.Header>
                  <Card.Body>
                    <Table responsive size="sm" className="mb-0">
                      <tbody>
                        {amount10 > 0 && (
                          <tr>
                            <td className="text-muted" style={{ width: 120 }}>Tờ 10K</td>
                            <td className="fw-bold">{amount10}</td>
                          </tr>
                        )}
                        {amount20 > 0 && (
                          <tr>
                            <td className="text-muted">Tờ 20K</td>
                            <td className="fw-bold">{amount20}</td>
                          </tr>
                        )}
                        {amount50 > 0 && (
                          <tr>
                            <td className="text-muted">Tờ 50K</td>
                            <td className="fw-bold">{amount50}</td>
                          </tr>
                        )}
                        <tr>
                          <td className="text-muted fw-bold">Tổng</td>
                          <td className="fw-bold text-primary">{totalSheets} tờ</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            )}

            {/* Hình ảnh */}
            {images && (images[0] || images[1]) && (
              <Col md={isDone === 1 && totalSheets > 0 ? 6 : 12}>
                <Card border="light" className="shadow-sm h-100">
                  <Card.Header className="bg-light fw-bold">Hình ảnh vé</Card.Header>
                  <Card.Body>
                    <div className="d-flex gap-3 justify-content-center flex-wrap">
                      {images[0] && (
                        <div
                          className="rounded overflow-hidden shadow-sm"
                          style={{ cursor: "pointer", maxWidth: 250 }}
                          onClick={() => showImagePreview("Ảnh 1", images[0])}
                        >
                          <img
                            alt="Ảnh vé 1"
                            src={images[0]}
                            style={{ width: "100%", height: "auto", maxHeight: 300, objectFit: "contain" }}
                          />
                        </div>
                      )}
                      {images[1] && (
                        <div
                          className="rounded overflow-hidden shadow-sm"
                          style={{ cursor: "pointer", maxWidth: 250 }}
                          onClick={() => showImagePreview("Ảnh 2", images[1])}
                        >
                          <img
                            alt="Ảnh vé 2"
                            src={images[1]}
                            style={{ width: "100%", height: "auto", maxHeight: 300, objectFit: "contain" }}
                          />
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>

      <ImagePreview
        show={imagePreviewShow}
        title={selectedImageTitle}
        image={selectedImage}
        onHide={() => setImagePreviewShow(false)}
      />
    </>
  );
}
